import JSZip from 'jszip'
import { downloadNameForBatch } from './download'
import { extensionFor, MAX_QUEUE_ITEMS } from './fileValidation'
import type { OutputFormat } from '../types'

export interface ZipEntry {
  fileName: string
  blob: Blob
}

export async function buildZipBlob(entries: ZipEntry[], outputFormat: Exclude<OutputFormat, 'pdf'>): Promise<Blob> {
  if (entries.length === 0) throw new Error('At least one converted image is required')
  if (entries.length > MAX_QUEUE_ITEMS) {
    throw new Error(`A ZIP can contain up to ${MAX_QUEUE_ITEMS} files per conversion`)
  }
  const zip = new JSZip()
  const extension = extensionFor(outputFormat)
  const buffers: Uint8Array[] = []
  try {
    for (const { fileName, blob } of entries) {
      const bytes = new Uint8Array(await blob.arrayBuffer())
      buffers.push(bytes)
      zip.file(`${fileName}.${extension}`, bytes)
    }
    return await zip.generateAsync({ type: 'blob', compression: 'DEFLATE', compressionOptions: { level: 6 } })
  } finally {
    buffers.forEach((bytes) => bytes.fill(0))
  }
}

export function zipDownloadName(outputFormat: Exclude<OutputFormat, 'pdf'>): string {
  return downloadNameForBatch(outputFormat)
}